import proTheme from './pro.json';
import defaultTheme from './default.json';
var theme = {
  defaultTheme: defaultTheme,
  proTheme: proTheme
};
export default theme;